import Vue from 'vue'

export const formatToDateString = (date) => {

  return Vue.moment(date).format('YYYY-MM-DD')
}

export const getDatesDiffInMonth = (endDate, startDate) => {
  const durationsDiff = Vue.moment.duration(
    Vue.moment(endDate).diff(Vue.moment(startDate))
  ).asMonths()

  return Math.abs(durationsDiff)
}

export const formatDateBySpecificFormat = (date, format) => {
  return Vue.moment(date).format(format)
}

export const getDateAndTimeFromDateTimeString = (datetimeString) => {
  const datetimeObject = new Date(datetimeString)
  if (!datetimeString || datetimeObject.toString() === 'Invalid Date') {
    return datetimeString
  }

  return {
    date: formatDateBySpecificFormat(datetimeObject, 'MMMM D, YYYY'),
    time: formatDateBySpecificFormat(datetimeObject, 'HH:mm')
  }
}